import { Outlet } from "react-router-dom"
import { DocumentHeadUpdater } from "@/components/DocumentHeadUpdater"

export default function AuthLayout() {
    return (
        <>
            <DocumentHeadUpdater />
            <div className="min-h-screen bg-muted/30 relative overflow-hidden flex items-center justify-center p-4 sm:p-6 md:p-8">
                {/* Animated gradient background orbs */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    {/* Top right orb */}
                    <div 
                        className="absolute -top-[40%] -right-[20%] w-[60%] h-[60%] rounded-full bg-primary/[0.08] dark:bg-primary/[0.12] blur-3xl animate-pulse"
                        style={{ animationDuration: '8s' }}
                    />
                    {/* Bottom left orb */}
                    <div 
                        className="absolute -bottom-[40%] -left-[20%] w-[60%] h-[60%] rounded-full bg-primary/[0.10] dark:bg-primary/[0.15] blur-3xl animate-pulse"
                        style={{ animationDuration: '8s', animationDelay: '4s' }}
                    />
                    {/* Center subtle glow */}
                    <div 
                        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50%] h-[50%] rounded-full bg-primary/[0.06] dark:bg-primary/[0.10] blur-3xl animate-pulse"
                        style={{ animationDuration: '10s', animationDelay: '2s' }}
                    />
                </div>
                
                {/* Content */}
                <div className="relative z-10 w-full">
                    <Outlet />
                </div>
            </div>
        </>
    )
}

